import { atom, useAtomValue, useSetAtom } from 'jotai';

export const searchOpenAtom = atom<boolean>(false);

export const useToggleSearchModal = () => useSetAtom(searchOpenAtom);
export const useIsSearchOpen = () => useAtomValue(searchOpenAtom);
